import { ApplicationState } from '.';

const initialState: ApplicationState = {
    internalUser: {
        userName: '',
        userType: undefined,
        accessTokens: {},
        roles: [],
        requestedPage: undefined,
        isAuthenticated: false,
        authenticating: false,
        msalReady: false,
        idToken: undefined,
        employeeid: undefined,
        useremail: undefined
    },
    empData:  {
            employeeDetail: {
                employeeId: "",
                employeeFirstName: "",
                employeeLastName: "",
                userPrincipalName: "",
                stationName: "",
                contractName: "",
                isActiveQuestionApplyPTO: "",
                commentLengthCheck: 0,
                allowNoScheduleCallout: false,
                isActiveQuestionJuryDuty: false,
                isActiveQuestionBereavement: false,
                absentPoints: null,
            },
            schedules: [
                {
                    employeeId: '',
                    scheduleId: '',
                    stringSchedule_StartTime: '',
                    stringSchedule_EndTime: '',
                    stringSchedule_Hours: '',
                    scheduleStartTimeUtc: '',
                    scheduleEndTimeUtc: '',
                    scheduleTimeRestrictionIsActive: false,
                    submissionHrWindow: 0,
                    notificationRejectionMessage: '',
                    scheduleCutoffHours: null,
                    scheduleCutoffHoursIsActive: false
                },
            ],
            absentDetails: [
                {
                absentReasonId: '',
                reasonDescription: ''
                },
            ]
            }
 };

export default initialState;
